import api from '../api/axiosInstance';

export const rappConfigService = {
  saveConfig: (flowId: string, ticketId: string, content: string) =>
    api.post(`/api/rapp-config/${flowId}/${ticketId}/config`, { content }),
  saveHelmParams: (flowId: string, ticketId: string, content: string) =>
    api.post(`/api/rapp-config/${flowId}/${ticketId}/helm-params`, { content }),
  saveRbac: (flowId: string, ticketId: string, content: string) =>
    api.post(`/api/rapp-config/${flowId}/${ticketId}/rbac`, { content }),
  getConfig: (flowId: string, ticketId: string) =>
    api.get(`/api/rapp-config/${flowId}/${ticketId}/config`),
  submit: (flowId: string, ticketId: string, body: { manifest: string; appname: string; appversion: string }) =>
    api.post(`/api/rapp-config/${flowId}/${ticketId}/submit`, body)
};
